import { useMutation, useQuery } from 'react-query';
import paths from 'API/paths';
import axiosInstance from 'Services/axiosConfig';


export interface TreatmentValue {
    contextId
    : 
  number;
    contextValue
    : 
    string;
    realmId: string;
    treatmentId : number;
    userId: number;
}

const getAllTreatmentValues = async (treatmentId:string) => {
  try {
    const url = paths.getTreatmentValue();
    const response = await axiosInstance.post(url, {input: {query:`featureTreatmentId==${treatmentId}`}});
    const treatmentValues = response?.data?.data?.treatmentValues?.result||[];

    const contextValues:string[] = treatmentValues.map((item:TreatmentValue) => {
     return  item.contextValue
    })
    const contextId:string = treatmentValues?.[0]?.contextId.toString()||'';
    return {contextValues,contextId};
  } catch (error) {
    return Promise.reject(error);
  }
  
};



export const useGetAllTreatmentValues = (treatmentId:string,options?:any) => {
  return useQuery(['get-treatment-value', treatmentId], () => getAllTreatmentValues(treatmentId), {
      refetchInterval: false,
      refetchOnWindowFocus: false,
  ...options
  });
};